import React, { useContext, useState } from 'react';
import { useTheme } from 'styled-components';

import { Button } from '../../button/button';
import DongleListCompanyAdmin from '../../dongles/dongle-list-company-admin';
import { RegisterDongleForm } from '../../dongles/register-dongle-form';
import { InfoBox } from '../../info-box/info-box';
import { Stack } from '../../stack/stack';
import { DeleteIntegrationDialog } from '../dialogs/delete-integration-dialog/delete-integration-dialog';
import { IntegrationTitle } from '../integration-title';
import {
  DonglesIntegrationItem,
  IntegrationsContext,
  IntegrationStatus,
} from '../state/integrations-state';
import { Component, Content, Footer, InfoItems } from './style';

interface Props {
  item: DonglesIntegrationItem;
}

const DonglesIntegration = (props: Props) => {
  const theme = useTheme();
  const [registerDongleFormOpen, setRegisterDongleFormOpen] = useState(false);
  const [deleteIntegrationDialogVisible, setDeleteIntegrationDialogVisible] = useState(false);
  const { skyMapDongleRegistrations } = useContext(IntegrationsContext);

  const closeRegisterForm = () => {
    setRegisterDongleFormOpen(false);
  };

  return (
    <Component>
      <IntegrationTitle>Enheter</IntegrationTitle>

      <Content>
        {props.item.status === IntegrationStatus.Setup &&
          skyMapDongleRegistrations.length === 0 && (
            <InfoBox
              bottomMargin={true}
              color="yellow"
              leftIcon={{ icon: ['fad', 'info'] }}
              topMargin={true}
              width="fit-content"
            >
              Lägg till en <strong>SkyMap Dongle</strong> för att aktivera integrationen.
            </InfoBox>
          )}
        <InfoItems>
          <Button
            disabled={registerDongleFormOpen}
            leftIcon={{ icon: ['fas', 'circle-plus'], color: theme.color.green }}
            variant={'text'}
            onClick={() => setRegisterDongleFormOpen(true)}
          >
            Lägg till ny enhet
          </Button>
          {registerDongleFormOpen && <RegisterDongleForm onClose={closeRegisterForm} />}

          {!registerDongleFormOpen && <DongleListCompanyAdmin />}
        </InfoItems>
      </Content>

      {!registerDongleFormOpen && (
        <Footer>
          <Stack direction="row" justifyContent={'flex-start'} spacing={0.5}>
            <Button
              color="primary"
              disabled={false}
              variant="contained"
              onClick={() => setDeleteIntegrationDialogVisible(true)}
            >
              Ta bort integration
            </Button>
          </Stack>
        </Footer>
      )}

      {deleteIntegrationDialogVisible && (
        <DeleteIntegrationDialog
          item={props.item}
          onClose={() => setDeleteIntegrationDialogVisible(false)}
        />
      )}
    </Component>
  );
};

export { DonglesIntegration };
